import React, {useEffect} from "react";

import Header from "../../components/header/Header";
import Benefits from "./components/Benefits";
import Accuracy from "./components/Accuracy";
import CallToAction from "./components/CallToAction";
import Functionality from "./components/Functionality";
import Steps from "./components/Steps";
import Ecosystem from "./components/Ecosystem";
import Business from "./components/Business";
import FAQ from "./components/FAQ";
import Contacts from "./components/Contacts";
// import Blog from "./components/Blog";
import CookieNotification from "./components/CookieNotification";

import RequestModal from "../../components/modal/RequestModal";
import {checkCounterHasExpired} from "../../services/checkCounterHasExpired";

import {useLazyGetArticlesQuery, useLazyGetTagsQuery} from "../../api/blog";

import styles from './Main.module.scss';

const DEMO_LINK = 'https://my.vedmarket.ru/register';

function Main() {

    const [open, setOpen] = React.useState(false);

    const [hasComment, setHasComment] = React.useState(false);

    const [ articlesRequest ] = useLazyGetArticlesQuery()

    const [ tagsRequest ] = useLazyGetTagsQuery()

    useEffect(() => {
        articlesRequest({});
        tagsRequest({});
    }, [ articlesRequest, tagsRequest ]);

    const handleOpen = () => {

        const counterHasExpired = checkCounterHasExpired();

        if (counterHasExpired) {
            window.open(DEMO_LINK, '_blank').focus();
        } else {
            setOpen(true);
        }

    }

    const handleClose = () => {
        setHasComment(false)
        setOpen(false);
    }

    const handleOpenWithComment = () => {
        setHasComment(true);
        setOpen(true);
    }

      return (
          <>
              <div className={styles.app}>
                  <Header handleOpen={handleOpen} />
                  <Benefits />
                  <Accuracy />
                  <CallToAction />
                  <Functionality />
                  <Steps />
                  <Ecosystem />
                  <Business/>
                  <FAQ handleOpen={handleOpenWithComment}/>
                  {/*<Blog*/}
                  {/*    handleOpen={handleOpenWithComment}*/}
                  {/*    articles={articles?.data.slice(0, 5)}*/}
                  {/*    tags={tags?.data}*/}
                  {/*/>*/}
                  <Contacts/>
                  <CookieNotification />
              </div>
              <RequestModal
                  open={open}
                  handleClose={handleClose}
                  hasComment={hasComment}
              />
          </>
      );
}

export default Main
